import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { FieldType } from '@ngx-formly/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  imports: [MatButtonModule, TranslateModule],
  selector: 'app-formly-field-button',
  template: `
    <div
      style="display: flex; justify-content: {{
        props.PosX || 'flex-start'
      }}; align-items: {{ props.PosY || 'center' }};"
    >
      <button
        [type]="props.btnType"
        mat-button
        [color]="props.color"
        (click)="onClick($event)"
      >
        {{ props.text | translate }}
      </button>
    </div>
  `,
})
export class FormlyButtonComponent extends FieldType {
  onClick($event: Event) {
    if (this.props.onClick) {
      this.props.onClick($event);
    }
  }
}
